import { render, staticRenderFns } from "./ServisFilterBar.vue?vue&type=template&id=f96705fc&scoped=true&"
import script from "./ServisFilterBar.vue?vue&type=script&lang=js&"
export * from "./ServisFilterBar.vue?vue&type=script&lang=js&"
import style0 from "./ServisFilterBar.vue?vue&type=style&index=0&id=f96705fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96705fc",
  null
  
)

export default component.exports